import { mountApp } from '@/apps/mount_app';
import NearbyHackathons from '@/components/devpost_homepage/NearbyHackathons.vue'

export default () => {
  mountApp({
    domId: "nearby-hackathons",
    component: NearbyHackathons
  })
}
